module.exports = __webpack_public_path__ + "static/media/JEST69.1973f458.jpg";